export default __webpack_public_path__ + "static/media/user-information.53d447a9.png";